var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index"}},[_c('PromoteBanner'),_c('GamesView',{attrs:{"game_infos":_vm.game_infos,"show_count":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }